import $ from 'jquery'

$(document).ready(function () {
  initSprintraceAccordion()
})

function initSprintraceAccordion() {
  $('.dhsv_vc_sprintrace_accordion').each(function () {
    const $accordion = $(this)
    const $items = $accordion.find('.sprintrace-accordion__item')

    $items.each(function () {
      const $item = $(this)
      const $toggle = $item.find('.sprintrace-accordion__toggle')
      const $content = $item.find('.sprintrace-accordion__content')

      // Initially hide content
      $content.slideUp(0)
      $item.removeClass('is-open')
      $toggle.attr('aria-expanded', 'false')

      // Toggle on click
      $toggle.on('click', function (e) {
        e.preventDefault()
        const isOpen = $item.hasClass('is-open')

        if (isOpen) {
          // Close
          $content.slideUp(300)
          $item.removeClass('is-open')
          $toggle.attr('aria-expanded', 'false')
        } else {
          // Close other items (optional - remove if you want multiple open)
          $items.not($item).each(function () {
            $(this).find('.sprintrace-accordion__content').slideUp(300)
            $(this).removeClass('is-open')
            $(this).find('.sprintrace-accordion__toggle').attr('aria-expanded', 'false')
          })

          // Open current item
          $content.slideDown(300)
          $item.addClass('is-open')
          $toggle.attr('aria-expanded', 'true')
        }
      })
    })
  })
}

